export const SCROLL_TO_TOP = "SCROLL_TO_TOP";
export const RESET_SCROLL = "RESET_SCROLL";

export const scrollToTop = () => ({
  type: SCROLL_TO_TOP,
});

export const resetScroll = () => ({
  type: RESET_SCROLL,
});
